export default function () {
  return {
    visitors: {},
    visitors_online: 0,
    visitors_today: 0,
    visitorsLoading: false,
    orders: {},
    orders_today: 0,
    orders_year: 0,
    ordersLoading: false,
    oferte: {},
    oferte_today: 0,
    oferte_year: 0,
    oferteLoading: false,
    oferte_wa: {},
    oferte_wa_today: 0,
    oferte_wa_year: 0,
    oferteWhatsappLoading: false
  }
}
